/**
 * Stack routes of the native screens added by the `developer` admin-module group
 * (its module defs live in system.js; only routes + locales + screens are separate).
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    // Generic config-driven developer / integration page (route param `page`, see screens/adminModules/developer/developerPages.js).
    {name: 'DeveloperPageScreen', component: lazyScreen(() => import('../../screens/adminModules/developer/DeveloperPageScreen'))},
];

export default ROUTES;
